<template>
  <main class="service-page">
    <section class="page-hero">
      <span>{{ content.heroLabel }}</span>
      <h1>{{ content.title }}</h1>
      <p>{{ content.description }}</p>
    </section>
    <section class="assessment-flow">
      <div class="flow-intro">
        <span>{{ content.logicLabel }}</span><h2>{{ content.sectionTitle }}</h2>
        <p>{{ content.sectionDescription }}</p>
      </div>
      <div class="flow-steps">
        <div v-for="item in content.flowSteps" :key="`${item.no}-${item.title}`"><b>{{ item.no }}</b><h3>{{ item.title }}</h3><p>{{ item.desc }}</p></div>
      </div>
    </section>
    <section class="category-section">
      <div class="section-head"><span>{{ content.categoryLabel }}</span><h2>{{ content.categoryTitle }}</h2></div>
      <div class="category-grid">
        <article v-for="item in content.categories" :key="`${item.no}-${item.title}`">
          <div class="category-no">{{ item.no }}</div><h3>{{ item.title }}</h3><p>{{ item.desc }}</p>
          <ul><li v-for="tag in tagsFor(item.tags)" :key="tag">{{ tag }}</li></ul>
        </article>
      </div>
    </section>
    <section class="fit-section">
      <div><strong>{{ content.smallTeamValue }}</strong><span>{{ content.smallTeamLabel }}</span></div><i></i><div><strong>{{ content.largeTeamValue }}</strong><span>{{ content.largeTeamLabel }}</span></div>
      <p>{{ content.fitDescription }}</p>
      <router-link to="/download">{{ content.fitButton }}</router-link>
    </section>
  </main>
</template>
<script>
import { loadSiteContent } from "../site-content";
import { getSiteContentDefaults } from "../site-content-config";

const defaultContent = getSiteContentDefaults("navigation");

export default {
  data() {
    return {
      content: defaultContent
    };
  },
  mounted() {
    loadSiteContent(this, "site.navigation", defaultContent).then(content => { this.content = content; });
  },
  methods: {
    tagsFor(value) {
      if (Array.isArray(value)) return value;
      return String(value || "").split(/[,，]/).map(tag => tag.trim()).filter(Boolean);
    }
  }
};
</script>
<style lang="scss" scoped>
.service-page { background: #fff; }.page-hero { padding: 100px 24px; text-align: center; color: #fff; background: linear-gradient(120deg,#1a2540,#3157c8 65%,#7046c8); }.page-hero span { color: #bdcaff; letter-spacing: 3px; font-size: 13px; }.page-hero h1 { margin: 16px 0; font-size: 48px; }.page-hero p { max-width: 720px; margin: auto; color: #e0e6f7; font-size: 17px; line-height: 1.8; }
.assessment-flow { max-width: 1160px; margin: 0 auto; padding: 90px 24px; display: grid; grid-template-columns: .85fr 1.4fr; gap: 70px; }.flow-intro span,.section-head span { color: #3157c8; font-size: 13px; font-weight: 700; letter-spacing: 3px; }.flow-intro h2 { margin: 16px 0; font-size: 34px; line-height: 1.4; }.flow-intro p { color: #68768d; line-height: 1.9; }.flow-steps { display: grid; grid-template-columns: repeat(2,1fr); gap: 16px; }.flow-steps div { padding: 25px; border: 1px solid #e4eaf5; border-radius: 12px; background:#f8faff; }.flow-steps b { color: #6b58cc; }.flow-steps h3 { margin: 14px 0 8px; }.flow-steps p { color: #77849a; font-size: 13px; }
.category-section { padding: 88px 24px; background: #f5f7fc; }.section-head { margin: 0 auto 42px; text-align:center; }.section-head h2 { margin-top: 14px; font-size: 34px; }.category-grid { max-width: 1120px; margin: auto; display: grid; grid-template-columns: repeat(4,1fr); gap: 16px; }.category-grid article { padding: 28px; min-height: 230px; border: 1px solid #e0e6f1; border-radius: 13px; background: #fff; transition: transform .2s, box-shadow .2s; }.category-grid article:hover { transform: translateY(-4px); box-shadow: 0 15px 30px rgba(46,60,102,.1); }.category-no { color:#8da0d5; font-size:13px; }.category-grid h3 { margin: 24px 0 10px; font-size:21px; }.category-grid p { min-height: 48px; color:#66748b; font-size:14px; line-height:1.7; }.category-grid ul { display:flex; gap:6px; margin-top:20px; flex-wrap:wrap; }.category-grid li { list-style:none; padding:5px 9px; border-radius:20px; color:#5368ad; background:#eef2ff; font-size:12px; }
.fit-section { padding: 70px 24px; display:flex; align-items:center; justify-content:center; gap:28px; flex-wrap:wrap; color:#fff; background:#172033; }.fit-section div { display:flex; flex-direction:column; text-align:center; }.fit-section strong { font-size:35px; }.fit-section span { color:#aab5c8; font-size:13px; }.fit-section i { width:50px; height:1px; background:#536078; }.fit-section p { max-width:420px; color:#aab5c8; line-height:1.8; }.fit-section a { padding:14px 24px; border-radius:8px; color:#3157c8; font-weight:700; text-decoration:none; background:#fff; }
@media(max-width:900px){.assessment-flow{grid-template-columns:1fr}.category-grid{grid-template-columns:repeat(2,1fr)}}@media(max-width:600px){.page-hero{padding:72px 20px}.page-hero h1{font-size:40px}.assessment-flow{padding:64px 20px;gap:38px}.flow-steps,.category-grid{grid-template-columns:1fr}.section-head h2,.flow-intro h2{font-size:29px}}
</style>
